
import { useCallback } from 'react';
import { TimeSlot, PsychologistSchedule, PricingData } from './types';

export const useSlotsGenerator = (
  scheduleBlocks: PsychologistSchedule[],
  bookedSlots: string[],
  pricing: PricingData
) => {
  // Gerar slots baseados na duração selecionada
  const generateSlots = useCallback((
    startTime: string,
    endTime: string,
    duration: number
  ): TimeSlot[] => {
    console.log('🔧 [useSlotsGenerator] Gerando slots:', { startTime, endTime, duration });
    console.log('💰 [useSlotsGenerator] Preços recebidos:', pricing);
    
    const slots: TimeSlot[] = [];
    const start = new Date(`2000-01-01T${startTime}`);
    const end = new Date(`2000-01-01T${endTime}`);
    
    const current = new Date(start);
    
    // CORREÇÃO: Usar preços reais do pricing com propriedades corretas
    const price = duration === 30 ? 
      (pricing.price_30min || 150) : 
      (pricing.price_60min || 280);
    
    console.log(`💵 [useSlotsGenerator] Usando preço REAL para ${duration}min: R$ ${price}`);
    
    while (current < end) {
      const slotTime = current.toTimeString().substring(0, 5);
      
      // Verificar se o slot cabe inteiramente no período
      const slotEnd = new Date(current.getTime() + duration * 60000);
      
      if (slotEnd <= end) {
        const isBooked = bookedSlots.includes(slotTime);
        
        slots.push({
          time: slotTime,
          available: !isBooked,
          duration,
          price: price // Preço real do banco
        });
      }
      
      // Avançar pelo intervalo da duração selecionada
      current.setMinutes(current.getMinutes() + duration);
    }
    
    console.log('✅ [useSlotsGenerator] Slots gerados com preços reais:', slots.length, 'para duração:', duration);
    return slots;
  }, [bookedSlots, pricing]);

  // Gerar todos os slots para uma duração específica
  const getAllSlotsForDuration = useCallback((duration: number): TimeSlot[] => {
    console.log('🎯 [getAllSlotsForDuration] Gerando slots para duração:', {
      duration,
      scheduleBlocksCount: scheduleBlocks.length,
      pricing
    });
    
    const allSlots: TimeSlot[] = [];
    
    scheduleBlocks.forEach(block => {
      const blockSlots = generateSlots(block.start_time, block.end_time, duration);
      allSlots.push(...blockSlots);
    });
    
    console.log('🎯 [getAllSlotsForDuration] Total de slots com preços reais para duração', duration, ':', allSlots.length);
    
    return allSlots;
  }, [scheduleBlocks, generateSlots]);

  // Agrupar slots por período do dia
  const getGroupedSlots = useCallback((duration: number) => {
    const slots = getAllSlotsForDuration(duration);
    
    const grouped = slots.reduce((acc, slot) => {
      const hour = parseInt(slot.time.split(':')[0], 10);
      let period = 'morning';
      
      if (hour >= 12 && hour < 18) {
        period = 'afternoon';
      } else if (hour >= 18) {
        period = 'evening';
      }
      
      if (!acc[period]) {
        acc[period] = [];
      }
      
      acc[period].push(slot);
      return acc;
    }, {} as Record<string, TimeSlot[]>);
    
    console.log('📊 [getGroupedSlots] Slots agrupados por período com preços reais:', {
      duration,
      periods: Object.keys(grouped),
      totalSlots: Object.values(grouped).flat().length
    });
    
    return grouped;
  }, [getAllSlotsForDuration]);

  return {
    generateSlots,
    getAllSlotsForDuration,
    getGroupedSlots
  };
};
